import { render, staticRenderFns } from "./mtcDetail.vue?vue&type=template&id=a874b2e6&scoped=true"
import script from "./mtcDetail.vue?vue&type=script&lang=js"
export * from "./mtcDetail.vue?vue&type=script&lang=js"
import style0 from "./mtcDetail.vue?vue&type=style&index=0&id=a874b2e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a874b2e6",
  null
  
)

export default component.exports